import React from 'react';
import { LucideIcon } from 'lucide-react';

interface AnimatedIconProps {
  icon: LucideIcon;
  className?: string;
}

export function AnimatedIcon({ icon: Icon, className = '' }: AnimatedIconProps) {
  return (
    <div className="absolute bottom-2 right-2 opacity-15">
      <Icon className={`w-8 h-8 animate-float ${className}`} />
    </div>
  );
}